import BybVrDialog from "@Components/game/common/dialog/byb-vr-dialog";
import { VideoDialogContent } from "./video-service/video-dialog-content";
import { useVideoDialog } from "./video-service/use-video-dialog";

const VideoService = () => {
  const { video, hideVideo, continueToChallenge } = useVideoDialog();

  return (
    <BybVrDialog
      name="video-player"
      open={Boolean(video)}
      onClose={hideVideo}
      showCloseButton
      width="70vw"
      sx={{
        "& .MuiDialog-paper": { overflow: "hidden", maxWidth: "95vw", bgcolor: "dsSurface.v300" },
        "& .MuiDialogContent-root": { p: 0 },
      }}
    >
      {video && <VideoDialogContent key={video.videoId} video={video} onContinue={continueToChallenge} />}
    </BybVrDialog>
  );
};

export default VideoService;
